import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { Link } from 'react-router-dom';
import { groupsQuery } from '@queries';
import { ChevronRightIcon } from '@svgs';

import AccountSidebar from '../components/AccountSidebar/AccountSidebar.jsx';
import Group from './Group/Group.jsx';

export const Groups = () => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  const { data: groups, isPending, isError } = useQuery(groupsQuery({}));

  // exclude access group types
  const filterGroups = (list) => {
    if (!list?.length) return [];
    // list of access group IDs, these are not shown in the UI
    const accessGroupIds = globals.whitelabel.oneoff_access_group_ids
      ? Object.values(globals.whitelabel.oneoff_access_group_ids)
      : [];

    return list.filter((g) => !accessGroupIds.includes(g.id));
  };

  return (
    <>
      <Header />
      <BodyWrapper>
        <AccountSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <span>Account settings</span>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>Groups</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Groups')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/groups/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>

            {isPending && <Loader className="sb-loader sb-loader-large" />}
            {groups && (
              <div className="sb-content-view-row">
                {filterGroups(groups.objects).map((group) => {
                  return <Group key={group.id} group={group} />;
                })}
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
